import { Component, Input } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { ILandType } from '@curbnturf/objects';
import { LandTypesFormComponent } from '../land-types-form/land-types-form.component';

@Component({
  selector: 'curbnturf-listing-terrain',
  templateUrl: './listing-terrain.component.html',
  styleUrls: ['./listing-terrain.component.scss'],
  standalone: true,
  imports: [LandTypesFormComponent],
})
export class ListingTerrainComponent {
  @Input() landTypes: FormArray<FormControl<ILandType['type'] | null>>;
}
